import { useQuery } from '@tanstack/react-query';
import { terminalRequestsApi } from '@/api/services/terminalRequests';

// Pending-count badge for the host "LP Requests Management" sidebar item
// (legacy menu counter). There is no dedicated SignalR hub for terminal
// requests, so we poll periodically. Returns null while unknown / disabled.
export function useTerminalRequestsBadge(enabled: boolean): number | null {
  const { data } = useQuery({
    queryKey: ['terminal-requests-pending-count'],
    queryFn: terminalRequestsApi.getPendingCount,
    enabled,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });

  return enabled ? data ?? null : null;
}
